import React from 'react';
import { Translate } from 'core/translate';
import { NetLine, Line } from './Lines';
import { PriceWithConditionalNotification } from './Price';

const NetPriceGroup = ({ pricing, config }) => {
  const { normalizedNetPriceDisplay } = pricing;
  const evData = config?.summary?.credits?.ev;
  const evProgram = evData?.program;
  const evProgramAmount = evData?.amount?.text;
  const evProgramDisclaimer = evData?.disclaimers;

  return (
    <>
      <NetLine
        label={<Translate value={'net.price'} />}
        price={
          <PriceWithConditionalNotification
            isNetPrice
            notificationName="msrp"
            useModal>
            {normalizedNetPriceDisplay}
          </PriceWithConditionalNotification>
        }
        className={evProgram ? 'hasEvProgram' : ''}
      />

      {evProgram && (
        <Line
          className={'math-box-evprogram'}
          label={evProgram}
          price={
            <PriceWithConditionalNotification
              useModal
              evProgramModal={evProgramDisclaimer}>
              {evProgramAmount}
            </PriceWithConditionalNotification>
          }
        />
      )}
    </>
  );
};

export default NetPriceGroup;
